import React, { useEffect } from 'react';
import { i18n } from 'utils/i18n';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import TaxesModalContent from './TaxesModalContent';

const TaxesModal = ({ taxesCopy, getTaxesPolicy }) => {
  useEffect(() => {
    if (!taxesCopy) {
      getTaxesPolicy();
    }
  }, []);

  return (
    <Modal
      modalKey={MODAL.RENTAL_DETAILS_TAXES_FEES_MODAL}
      theme={MODAL_THEMES.WHITE}
      header={i18n('rental_details_taxes_fees_modal_header')}
    >
      {() => <TaxesModalContent taxesCopy={taxesCopy} />}
    </Modal>
  );
};

export default TaxesModal;
